/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useConfig } from 'context/app-config';
import { EXCLUDED_PARTNERS_FROM_MEDIA_REQUEST } from 'hooks/usePartner';
import Page from 'layout/page';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectPartner } from 'redux-stores/slices/authSlice';
import { useBasePath } from 'utils/router/hooks/useBasePath';

import PhoneNumberForm from './phone-number-form';

interface Props {}

const PhoneNumberPage: React.FC<Props> = () => {
  const basePath = useBasePath();
  const config = useConfig();
  const navigate = useNavigate();
  const partner = useSelector(selectPartner);
  const { t } = useTranslation();

  const handleFormSubmit = useCallback(
    async (phoneNumber: string, country: string) => {
      navigate(`/${basePath}/verifyCode`, {
        state: {
          phone: phoneNumber,
          country,
        },
      });
    },
    [navigate]
  );

  return (
    <Page
      title={t('profilePage.logInAndSignUp')}
      description={config?.isAuthDisabled ? t('profilePage.logInViaPartner', { partner }) : t('profilePage.editPhoneDescription')}
      hasBack
      headerProps={{
        isShowPricingOption: false,
        isShowSupportOption: true,
      }}
      route={-1}
    >
      {config?.isAuthDisabled ? null : (
        <PhoneNumberForm onSuccess={handleFormSubmit} autoFocus={!EXCLUDED_PARTNERS_FROM_MEDIA_REQUEST.includes(partner)} />
      )}
    </Page>
  );
};

export default PhoneNumberPage;
